import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { login } from '../../actions';
import './login.css';

class Login extends Component {
  state = {
    email:'',
    password:'',
    error:'',
    success: false
  }

  componentWillMount = () => {
  }

  componentWillReceiveProps = (nextProps) => {
  }

  handleInputEmail = (env) => {
    this.setState({ email: env.target.value});
  }

  handleInputPassword = (env) => {
    this.setState({ password: env.target.value});
  }

  submitForm = (e) => {
    e.preventDefault();
    this.props.login(this.state);
  }

  render() {
    let user = this.props.loginStatus;

    return (
      <div className="">
        <form onSubmit={this.submitForm}>
          <h2>Login</h2>
          <div>
            <input 
              className="login-input"
              type="email"  
              placeholder="Enter Your Mail"
              value={this.state.email}
              onChange={this.handleInputEmail}
              />
            </div>
            <div>
            <input 
              className="login-input"
              type="password"  
              placeholder="Enter Your Password"
              value={this.state.password}
              onChange={this.handleInputPassword}
              />
          </div>
          <div>
            <button className="login-btn" type="submit">Log in</button>
          </div>
          <div className="error_message"> 
              {
                user.login ? 
                  <div>
                    {user.login.message}
                  </div>
                : null
              }
          </div>    
          </form>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
   loginStatus: state.login
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ login },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);